import { fg } from '@atlaskit/platform-feature-flags/fg';

export default {
	get(): boolean {
		return fg('mercury_web_enable_expanded_side_nav');
	},
};
